import { AmzMarketplaceIds } from './amazon-marketplace-ids';

export const MARKETPLACE_IDS_WITH_OWN_RETURNS = [...AmzMarketplaceIds];
